import React from 'react';
import {useState} from 'react';
import { Avatar, ListItem, ListItemAvatar, ListItemText, makeStyles, IconButton } from '@material-ui/core';
import { Description } from '@material-ui/icons';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import PreviewIcon from '@mui/icons-material/Preview';
import PdfViewerTool from '../../utils/PdfViewer';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

const useStyles = makeStyles(theme => ({
  avatar: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
  },
  listItemWrapper: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  backAttaches:{
    position: 'absolute',
    left: '0',
    bottom: '0',
  },
}));

const FileLoader = ({ data, action, viewFile, open, url }) => {
  
  const [openPdf, setOpenPdf] = useState(open);
  const [filesLength, setFilesLength] = useState(0);

  const handleOpenViewer = () => {
    setOpenPdf(true);
  };
  const handleCloseViewer = (e) => {
    setOpenPdf(false);
  };
  
  const classes = useStyles();
  
  return (
    <div style={{width:'100%', height:'95%'}} >
      {openPdf ? 
        <>
          <PdfViewerTool handleCloseViewer={handleCloseViewer} filePdf={url}/>
        </>  
        : 
        <>
          {data===undefined || data.length <= 0 ? 
            <Stack sx={{ width: '100%' }} spacing={2}>
              <Alert severity="info">El reclamo no contiene archivos Adjuntos</Alert>
            </Stack>
          :
            <div>
                {data &&
                  data.map((name, i) => (
              <ListItem key={i}>
                <ListItemAvatar>
                  <Avatar className={classes.avatar}>
                    <Description />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={name} />
                <IconButton
                  disabled={false}
                  aria-label="Visualizar"
                  size="large"
                  color="primary"
                  onClick={() => {
                    viewFile(name)
                    handleOpenViewer()
                    
                  }}
                >
                  <PreviewIcon/>
                </IconButton>
                <IconButton
                  disabled={false}
                  aria-label="Descargar"
                  size="large"
                  color="primary"
                  onClick={() => {
                    action(name)
                  }}
                >
                  <SimCardDownloadIcon/>
                </IconButton>
              </ListItem>
            ))}
            </div>
          }
        </>
      }
      
    </div>
  );
};

export default FileLoader;
